export default __webpack_public_path__ + "static/media/footer.6558e477.gif";